const httpMethods = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete',
};

const userTypes = {
  USER: 'USER',
  MASTER_USER: 'MASTER_USER',
};

const apiEndoints = {
  LIST_FILES: 'File',
  LIST_QUERIED_FILES: 'File/Search',
  DOCUMENT: 'Document',
  LIST_PARTNERS: 'Partner',
  LIST_QUERIED_PARTNERS: 'Partner/filter',
  USER: 'User',
};

const routePaths = {
  FILE_LIST_PAGE: '/',
  FILE_REVIEW_PAGE: '/review/:id',
  LOGIN_PAGE: '/login',
  PARTNERS: '/partners',
};

const pageLabels = {
  LOGIN: {},
  FILE_LIST: {
    TABLE_FILE_NUMBER_TITLE: 'File number',
    TABLE_ADDRESS_TITLE: 'Address',
    TABLE_STATUS_TITLE: 'Status',
    TABLE_DATE_CREATED_TITLE: 'Date created',
    FILTER_BMA: 'BMA',
    FILTER_APPRAISAL: 'Appraisal',
  },
  FILE_REVIEW: {},
  PARTNERS: {
    TABLE_PARTNER_NAME: 'Partner',
    TABLE_PARTNER_RATING: 'Rating',
    TABLE_PARTNER_BASE_CORE: 'Base Score',
  },
  PARTNER_DETAIL: {
    TABLE_BMA: 'BMA',
    TABLE_BMA_SCORE: 'BMA Score',
    TABLE_TOTAL_SCORE: 'Total Score',
    TABLE_PERCENT: 'Percent',
  },
};

const pageData = {
  LOGIN: {},
  FILE_LIST: {
    TABLE_COLUMNS_DATA: [
      {
        name: pageLabels.FILE_LIST.TABLE_FILE_NUMBER_TITLE,
        selector: 'fileNumber',
        isStatus: false,
        isRating: false,
      },
      {
        name: pageLabels.FILE_LIST.TABLE_ADDRESS_TITLE,
        selector: 'address',
        isStatus: false,
        isRating: false,
      },
      {
        name: pageLabels.FILE_LIST.TABLE_STATUS_TITLE,
        selector: 'statusTitle',
        isStatus: true,
        isRating: false,
      },
      {
        name: pageLabels.FILE_LIST.TABLE_DATE_CREATED_TITLE,
        selector: 'date',
        isStatus: false,
        isRating: false,
      },
    ],
  },
  FILE_REVIEW: {},
  PARTNERS: {
    TABLE_COLUMNS_DATA: [
      {
        name: pageLabels.PARTNERS.TABLE_PARTNER_NAME,
        selector: 'partnerCompanyName',
        isStatus: false,
        isRating: false,
      },
      {
        name: pageLabels.PARTNERS.TABLE_PARTNER_RATING,
        selector: 'rating',
        isStatus: false,
        isRating: true,
      },
      {
        name: pageLabels.PARTNERS.TABLE_PARTNER_BASE_CORE,
        selector: 'scoreAdjustment',
        isStatus: false,
        isRating: false,
      },
    ],
  },
  PARTNER_DOCUMENTS: {
    TABLE_COLUMNS_DATA: [
      {
        name: pageLabels.PARTNER_DETAIL.TABLE_BMA,
        selector: 'createdDate',
        isStatus: false,
        isRating: false,
      },
      {
        name: pageLabels.PARTNER_DETAIL.TABLE_BMA_SCORE,
        selector: 'bmaScore',
        isStatus: false,
        isRating: false,
      },
      {
        name: pageLabels.PARTNER_DETAIL.TABLE_TOTAL_SCORE,
        selector: 'totalScore',
        isStatus: false,
        isRating: false,
      },
      {
        name: pageLabels.PARTNER_DETAIL.TABLE_PERCENT,
        selector: 'percent',
        isStatus: false,
        isRating: false,
      },
    ],
  },
};

const componentLabels = {
  NAVBAR: {
    LOGOUT_LABEL: 'Logout',
    PARTNERS: 'Partners',
  },
};

const urlRouter = {
  FILE_REVIEW_PAGE: '/review',
  PARTNERS: '/partners',
};

const statusFile = {
  OPEN: 'Open',
  SAVED_REVIEW_SHEET: 'SavedReviewSheet',
  CLOSED: 'Closed',
  REPORT_SAVED: 'REPORT SAVED',
};

const fileDateSortDirections = {
  DESCENDING: 'Descending',
  ASCENDING: 'Ascending',
};

const fileListFilterDefaults = {
  startDate: '',
  endDate: '',
  status: '',
  sortDirection: fileDateSortDirections.DESCENDING,
};

const fileStatusFilterOptions = [
  { label: 'All statuses', value: '' },
  { label: 'Open', value: statusFile.OPEN },
  { label: 'Report Saved', value: statusFile.SAVED_REVIEW_SHEET },
  { label: 'Closed', value: statusFile.CLOSED },
];

const fileDateSortOptions = [
  { label: 'Newest first', value: fileDateSortDirections.DESCENDING },
  { label: 'Oldest first', value: fileDateSortDirections.ASCENDING },
];

const documentTypes = {
  BMA: 'bma',
  APPRAISAL: 'appraisal',
};

const documentTypeConfig = {
  [documentTypes.BMA]: {
    ids: [1333, 1334, 1335],
    label: 'BMA',
    summaryLabel: 'BMA Document',
  },
  [documentTypes.APPRAISAL]: {
    ids: [40],
    label: 'Appraisal',
    summaryLabel: 'Appraisal Document',
  },
};

const getDocumentTypeConfig = documentType =>
  documentTypeConfig[documentType] || documentTypeConfig[documentTypes.BMA];

const getDocumentsByType = (documents, documentType) =>
  (documents || []).filter(document =>
    getDocumentTypeConfig(documentType).ids.includes(document?.reswareDocumentTypeId),
  );

const getDocumentTypeSummaryLabel = (documentType, count) => {
  const { summaryLabel } = getDocumentTypeConfig(documentType);
  return `${summaryLabel}${count !== 1 ? 's' : ''}`;
};

export {
  httpMethods,
  apiEndoints,
  userTypes,
  routePaths,
  pageLabels,
  pageData,
  componentLabels,
  urlRouter,
  statusFile,
  fileDateSortDirections,
  fileListFilterDefaults,
  fileStatusFilterOptions,
  fileDateSortOptions,
  documentTypes,
  getDocumentTypeConfig,
  getDocumentsByType,
  getDocumentTypeSummaryLabel,
};
